import {createIssueRootCauseCategoryAction, showNotificationAction} from '../../../app/actions';
import {isCreatingRootCausesAdmin, getIssueRootCauseCategoryNames} from '../../../app/selectors';
import {connect} from '../../../app/connect';
import IssueRootCauseCategoryAdminCreateModal from './IssueRootCauseCategoryAdminCreateModal';

const mapStateToProps = state => ({
  isCreating: isCreatingRootCausesAdmin(state),
  issueRootCauseCategoryNames: getIssueRootCauseCategoryNames(state)
});

const mapDispatchToProps = {
  createIssueRootCauseCategoryAction,
  showNotificationAction
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IssueRootCauseCategoryAdminCreateModal);
